<template>
  <div>
    <Modal
      v-model="show"
      :title="type == 'add' ?$t('add'):$t('edit')"
      :mask-closable="false"
      width="800"
      @on-cancel="cancel"
    >
      <div class="modal">
        <Form ref="form" :model="form" :rules="ruleInline" inline :label-width="120" label-colon>
          <div class="item">
              <FormItem class="item_input" prop="email" :label="$t('email')">
                <Input type="text" v-model="form.email" :placeholder="$t('emailInput')"></Input>
              </FormItem>
         </div>
        </Form>
      </div>
      <div slot="footer">
        <Button @click="cancel()">{{ $t("cancel") }}</Button>
        <Button type="primary" @click="submit('form')">{{ $t("sure") }}</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  props: {
    modal: {
      type: Boolean,
      default: false,
    },
    itemObj: Object,
    type: String,
  },
  data () {
    return {
      form: {
        white_id:'',
        email:'',
      },
      ruleInline: {
        email: [
          {
            required: true,
            message: this.$t("emailInput"),
            trigger: "blur"
          }
        ],
      },
      show: this.modal,

    }

  },
  created () {
    this.info()
  },
  mounted () {

  },
  methods: {
    info () {
      if (this.type != 'add') {
        this.form = {
          white_id: this.itemObj.white_id,
          email: this.itemObj.email,
        }
      }
    },
    cancel () {
      this.$emit('cancel');
    },
    error () {
      this.$Message.error(this.$t("improve_information"));
    },
    handleBeforeUpload (file) {
      this.$base.showLoading();
      this.$base.uploadPicimg(file, '').then(res => {
        this.$base.hideLoading();
        if (res.url) {
          this.form.reg_image = res.url
        }
      });
    },
    submit (name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.$base.showLoading();
          this.$request.sendPost(
            this.type == 'add' ? 'school-white/add' : 'school-white/upd',
            this.form,
            (success, data, error) => {
              this.$base.hideLoading();
              if (!success) return this.$base.alertErr(error.errmsg);
              this.cancel()
              this.$emit('onOk');
            }
          );
        } else {
          this.error()
        }
      });
    },
  }
}
</script>

<style lang="less" scoped>
/deep/ .modal {
  .ivu-tabs .ivu-tabs-tabpane {
    margin-top: 40px;
  }
  .item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 80%;
    margin: 0 0 20px 10%;
  }
  .tabs_item {
    width: 80%;
    margin: 20px 0 0 10%;
    .item_input {
      width: 100%;
      padding-right: 10px;
    }
  }
  .ivu-tabs-nav-scroll {
    display: flex;
    justify-content: center;
  }
  .demo-upload-list {
    display: inline-block;
    width: 150px;
    height: 150px;
    text-align: center;
    line-height: 100px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    margin-right: 4px;
  }
  .demo-upload-list img {
    width: 100%;
    height: 100%;
    border: 1px solid #dcdee2;
  }
  .ivu-upload-drag {
    height: 150px;
  }
  .photo_tip{
      color: #c5c8ce;
      font-size: 13px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/school/white/module/white_edit.vue